import { useIntl } from '@umijs/max';
import type { ModalFuncProps } from 'antd';
import { Modal } from 'antd';

export enum ModalType {
  warning = 'warning',
  info = 'info',
  success = 'success',
  confirm = 'confirm',
}

export const useModal = <TResult = undefined | void | null>(
  type: ModalType,
  title?: string,
  okAction?: (params: TResult) => Promise<any>,
  cancelAction?: (params: TResult) => Promise<any>,
  options?: Omit<ModalFuncProps, 'title' | 'onOk' | 'onCancel'>,
) => {
  const intl = useIntl();

  const { okText, cancelText, ...otherProps } = options || {};
  const defaultProps = {
    ...otherProps,
    title,
    okText:
      okText ||
      intl.formatMessage({ id: 'modal.button.ok', defaultMessage: 'Đồng ý' }),
    cancelText:
      cancelText ||
      intl.formatMessage({
        id: 'modal.button.cancel',
        defaultMessage: 'Hủy bỏ',
      }),
  };

  const show = (
    params: TResult,
    overrideOptions?: Omit<ModalFuncProps, 'title' | 'onOk' | 'onCancel'>,
  ) => {
    Modal[type]({
      ...defaultProps,
      ...overrideOptions,
      onOk: () => okAction?.(params),
      onCancel: () => cancelAction?.(params),
    });
  };

  return { show };
};
